import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import InLineRotaryMixer from 'features/processFlowDiagrams/svg/mixers/in-line-rotary-mixer.svg?react'
import InLineStaticMixer from 'features/processFlowDiagrams/svg/mixers/in-line-static-mixer.svg?react'
import Kneader from 'features/processFlowDiagrams/svg/mixers/kneader.svg?react'
import MixingPath from 'features/processFlowDiagrams/svg/mixers/mixing-path.svg?react'
import React from 'react'

export const PID_MIXERS_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'in-line-rotary-mixer',
    name: 'In-Line Rotary Mixer',
    category: 'mixers',
    svgContent: <InLineRotaryMixer />,
    viewBox: '0 0 190 100',
  },
  {
    id: 'in-line-static-mixer',
    name: 'In-Line Static Mixer',
    category: 'mixers',
    svgContent: <InLineStaticMixer />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'kneader',
    name: 'Kneader',
    category: 'mixers',
    svgContent: <Kneader />,
    viewBox: '0 0 170 100',
  },
  {
    id: 'mixing-path',
    name: 'Mixing Path',
    category: 'mixers',
    svgContent: <MixingPath />,
    viewBox: '0 0 260 100',
  },
]
